import { PropTypes } from 'prop-types';
import {
  Table,
  TableHead,
  TableContainer,
  TableRow,
  TableCell,
  Box,
  TableBody
} from "@mui/material";
import { useMemo } from 'react';
import { Duration } from 'luxon';

function SmartPTFullTable({ label, amountOfServices, initialSuggestedTime, numberOfBays }) {

  const suggestedTime = useMemo(() => {

    const times = [...Array(numberOfBays)].map((bay, index) => {
      const waitingTime = initialSuggestedTime?.map((time) => {
        const customersInQueue = index;
        const [hours, minutes] = time.split(':').map(Number);
        const duration = Duration.fromObject({ hours, minutes });
        const minutesToAdd = customersInQueue * 10;
        const newDuration = duration.plus({ minutes: minutesToAdd }).normalize();;
        return `${newDuration.hours}:${newDuration.minutes.toString().padStart(2, '0')}`;
      });

      return waitingTime;

    })

    return times;

  }, [initialSuggestedTime]);

  return (
    <Box>
      <p className='bg-yellow font-bold pl-1 text-base m-0'>
        {label}
      </p>
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                className='p-1 font-bold border border-solid border-gray-300 text-sm capitalize w-20'
                rowSpan={2}
              >
                Vehicles in queue
              </TableCell>
              <TableCell 
                align='left' 
                className='p-1 font-bold border border-solid border-gray-300 text-sm capitalize'
                colSpan={amountOfServices}>
                Services requested
              </TableCell>
            </TableRow>
            <TableRow>
              {
                [...Array(amountOfServices)].map((service, index) => (
                  <TableCell
                    key={index}
                    component="th"
                    scope="row"
                    align="center"
                    className='p-1 border border-solid border-gray-300 text-sm text-gray-500 font-bold'
                  >
                    {index + 1}
                  </TableCell>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              [...Array(numberOfBays)].map((bay, index) => (
                <TableRow
                  key={index}
                >
                  <TableCell
                    align="center"
                    className='p-1 border border-solid border-gray-300 text-sm text-gray-500 font-bold'
                  >
                    {index}
                  </TableCell>
                  {
                    suggestedTime[index].map((suggestedTime, index) => (
                      <TableCell
                        key={index}
                        align="center"
                        className='border border-solid border-gray-300 text-sm'
                      >
                        {suggestedTime}
                      </TableCell>
                    ))
                  }
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

SmartPTFullTable.propTypes = {
  label: PropTypes.string.isRequired,
  amountOfServices: PropTypes.number.isRequired,
  initialSuggestedTime: PropTypes.array.isRequired,
  numberOfBays: PropTypes.number.isRequired,
};

export default SmartPTFullTable;